/**
 * NAD3-60 Live Orders Popup - JavaScript
 */

// Array of sample orders for NAD3-60
const orders = [
    { name: "Sandra", location: "Hawaii", product: "NAD3 60 - 1 Bottle", time: "Just now" },
    { name: "Nikki", location: "California", product: "NAD3 60 - 1 Bottle", time: "2 minutes ago" },
    { name: "Roland", location: "Texas", product: "NAD3 60 - 1 Bottle", time: "5 minutes ago" },
    { name: "Susan", location: "Ohio", product: "NAD3 60 - 1 Bottle", time: "8 minutes ago" },
    { name: "Sofia", location: "Florida", product: "NAD3 60 - 1 Bottle", time: "10 minutes ago" },
    { name: "Lidia", location: "Georgia", product: "NAD3 60 - 1 Bottle", time: "12 minutes ago" },
    { name: "Norma", location: "Illinois", product: "NAD3 60 - 3 Bottles", time: "15 minutes ago" },
    { name: "Kenneth", location: "Georgia", product: "NAD3 60 - 1 Bottle", time: "18 minutes ago" },
    { name: "Vickey", location: "New York", product: "NAD3 60 - 1 Bottle", time: "20 minutes ago" },
    { name: "Stacy", location: "Illinois", product: "NAD3 60 - 3 Bottles", time: "25 minutes ago" },
    { name: "Anthea", location: "New York", product: "NAD3 60 - 2 Bottles", time: "30 minutes ago" },
    { name: "Norma", location: "Nevada", product: "NAD3 60 - 3 Bottles", time: "35 minutes ago" },
    { name: "Tina", location: "Alabama", product: "NAD3 60 - 1 Bottle", time: "40 minutes ago" },
    { name: "Burt", location: "California", product: "NAD3 60 - 2 Bottles", time: "45 minutes ago" },
    { name: "Lorna", location: "Washington", product: "NAD3 60 - 1 Bottle", time: "50 minutes ago" },
    { name: "Maria", location: "Georgia", product: "NAD3 60 - 3 Bottles", time: "Just now" },
    { name: "Kelly", location: "Ohio", product: "NAD3 60 - 1 Bottle", time: "2 minutes ago" },
    { name: "Doris", location: "New Mexico", product: "NAD3 60 - 1 Bottle", time: "5 minutes ago" },
    { name: "Thao", location: "Texas", product: "NAD3 60 - 3 Bottles", time: "8 minutes ago" },
    { name: "Andre", location: "Texas", product: "NAD3 60 - 1 Bottle", time: "10 minutes ago" },
    { name: "Tracy", location: "Vermont", product: "NAD3 60 - 1 Bottle", time: "12 minutes ago" },
    { name: "Clint", location: "Texas", product: "NAD3 60 - 3 Bottles", time: "15 minutes ago" },
    { name: "Kathleen", location: "New York", product: "NAD3 60 - 1 Bottle", time: "18 minutes ago" },
    { name: "Karen", location: "Texas", product: "NAD3 60 - 1 Bottle", time: "20 minutes ago" },
    { name: "Keepe", location: "North Carolina", product: "NAD3 60 - 3 Bottles", time: "25 minutes ago" },
    { name: "Jeff", location: "South Carolina", product: "NAD3 60 - 1 Bottle", time: "30 minutes ago" },
    { name: "Nathan", location: "Arizona", product: "NAD3 60 - 3 Bottles", time: "35 minutes ago" },
    { name: "Ranjit", location: "Michigan", product: "NAD3 60 - 1 Bottle", time: "40 minutes ago" },
    { name: "Alejandro", location: "Arkansas", product: "NAD3 60 - 3 Bottles", time: "45 minutes ago" },
    { name: "John", location: "Nebraska", product: "NAD3 60 - 1 Bottles", time: "50 minutes ago" }
];

// Display popup function
function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    
    popup.innerHTML = `
        <div class="popup-content">
            <div class="popup-image">
                <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon_NAD3_60ct_Page01.jpg?v=1733346589" alt="Product Image">
                <span class="glow-dot"></span>
            </div>
            <div class="popup-text">
                <div class="popup-line">
                    <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
                </div>
                <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
                <div class="popup-line order-time">${randomOrder.time}</div>
                <div class="verified-buyer-badge">Verified Buyer</div>
            </div>
        </div>
    `;
    
    popup.style.display = 'block';

    setTimeout(() => {
        popup.classList.add('popup-hide');
    }, 6000);

    setTimeout(() => {
        popup.style.display = 'none';
        popup.classList.remove('popup-hide');
        setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
}

// Random time intervals between popups
function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
}

// Start the popup display
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
});
